import {
  RoomDescription,
  roomDescription,
  RoomStartAt,
  roomStartAt,
  RoomTitle,
  roomTitle
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomCreateCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomCreateCmd.validationSchema()
  );

  constructor(readonly value: RoomCreateCmmdRaw) {
    JsonSchemaValidator.assert(RoomCreateCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["title"],
      properties: {
        title: roomTitle,
        description: roomDescription,
        startAt: roomStartAt
      },
      additionalProperties: false
    };
  }
}

interface RoomCreateCmmdRaw {
  title: RoomTitle;
  description?: RoomDescription;
  startAt?: RoomStartAt;
}
